import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { classNames } from '../tools/helpers';
import { getSite } from '../tools/fetcher';
import Button from "./Button";

export default function Hero({ className }) {
    const { data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    return (
        <div className={classNames('flex flex-col gap-4 items-center', className)}>
            <div className={'flex flex-col items-center space-y-2 text-center z-10 sm:max-w-[814px] sm:space-y-4'}>
                <p
                    className={
                        'font-bold leading-[36px] text-[32px] text-primary-green-101 sm:leading-[76px] sm:text-[64px]'
                    }
                >
                    {data?.hero?.title}
                </p>
                <p className={'text-sm text-primary-gray-100 sm:leading-7 sm:max-w-[592px] sm:text-base'}>
                    {data?.hero?.description}
                </p>
                <Button
                    className={
                        'leading-6 mt-4 text-sm w-fit sm:text-base'
                    }
                    type="a"
                    href={data?.hero_button?.link_url}
                    target="_blank"
                >
                    {data?.hero_button?.description}
                </Button>
            </div>
            {data?.hero?.image_src && (
                <div className={'absolute hidden top-[383px] z-0 md:block'}>
                    <img
                        src={data?.hero?.image_src}
                        alt={data?.hero?.image_alt}
                    />
                </div>
            )}
        </div>
    );
}
